import { IDreamTeamData } from "core-integration/src/store/dream-teams/types";
import { getElementsById } from "core-integration/src/store/elements/reducers";
import { IEvent } from "core-integration/src/store/events/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import ElementAvatar from "plos/src/components/avatars/ElementAvatar";
import MoreLink from "plos/src/components/links/MoreLink";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  pointsPanel,
  primaryPanel,
} from "../PointsScoreboard/pointsScoreboard.css";
import {
  headerItem,
  headerWrapper,
  itemHeading,
  playerInfoWrapper,
  points,
  pointsContainer,
  pointValue,
  subheading,
} from "./dreamTeam.css";

interface DreamTeamScoreboardProps {
  event: IEvent;
  data: IDreamTeamData;
  now: IEvent;
}

const DreamTeamScoreboard = ({
  event,
  data,
  now,
}: DreamTeamScoreboardProps) => {
  const { t } = useTranslation("dreamTeam");

  const teamsById = useSelector(getTeamsById);
  const elementsById = useSelector(getElementsById);
  const topPlayer = elementsById[data.top_player.id];

  return (
    <div className={headerWrapper}>
      <div className={headerItem}>
        <h3 className={itemHeading}>{t("totalPoints", "Total Points")}</h3>
        <div className={pointsContainer}>
          <div className={primaryPanel}>
            <div className={pointsPanel}>
              <div className={pointValue}>
                {data.team
                  .reduce((total, e) => total + e.points, 0)
                  .toLocaleString()}
              </div>
            </div>
          </div>
        </div>
        {event ? (
          <MoreLink to="/team-of-the-week/">
            <span className={subheading}>{t("overall", "Overall")}</span>
          </MoreLink>
        ) : (
          <MoreLink to={`/team-of-the-week/${now.id}`}>
            <span className={subheading}>{t("gameweek", "Gameweek")}</span>
          </MoreLink>
        )}
      </div>
      <div className={headerItem}>
        <h3 className={itemHeading}>
          {event
            ? t("playerOfTheWeek", "Player of the Week")
            : t("playerOfTheSeason", "Player of the Season")}
        </h3>
        <ElementAvatar element={topPlayer} size="large" />
        <div className={playerInfoWrapper}>
          <span className={subheading}>{topPlayer.web_name}</span>
          <div className={points}>
            {t("teamPoints", "{{teamShortName}} {{playerPoints}}pts", {
              teamShortName: teamsById[topPlayer.team].short_name,
              playerPoints: data.top_player.points,
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DreamTeamScoreboard;
